import { RPCFactory } from '../utils/RequestUtil';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { XundaStateAction } from '../actions/XundaStateAction';

// 通过使用高阶组件向目标组件注入 redux store 中的讯达的数据
const HOC = (props) => {
  const Component = props.component;
  const dispatch = useDispatch();
  const xundaData = useSelector((state) => state.xunda);

  useEffect(() => {
    if (xundaData.status !== 'init') return;
    // 只有车讯达需要获取楼盘列表
    if (/^6/.test(window.pageProps.xundaOuterCode)) {
      RPCFactory.xunda.getPoolData().done((data) => {
        dispatch({
          type: XundaStateAction.SET_FXD_POOL,
          payload: {
            name: data.leads_pool_desc,
            pool: data.leads_pool_list || [],
          },
        });
      });
    }
  }, [xundaData.status]);

  return (<Component {...props._props} xundaData={xundaData} />);
};

export const withXundaData = (component) => (props) => (<HOC _props={props} component={component} />);
